import React, { useState, useEffect } from 'react';
import { Link, useHistory } from 'react-router-dom';
import Select from 'react-select';
import { useDispatch, useSelector } from 'react-redux';
import jmoment from 'moment-jalaali';

import useSetState from '../../../../hooks/useSetState';
import ShowForPermission from '../../../../components/ShowForPermission';
import DatePicker from '../../../../components/FormElements/DatePicker/DatePicker';
import RseeTimePicker from '../../../../components/timePicker';
import FailedMessagesList from '../../../../components/failedMesasgesList';
import ENUMS from '../../../../enums';
import { getAllCafeNamesForPanel } from '../../../../redux/cafes/actions';
import {
  newReservationTiming,
  getReservationTimingDetails,
  editReservationTiming,
} from '../../../../redux/reservationTiming/actions';

import { formatter, permissionHelper } from '../../../../utils';

import style from './style.scss';

const AddOrEditReservationTiming = props => {
  const [cafeItemInputError, setCafeItemInputError] = useState();
  const [fromDateError, setFromDateError] = useState();
  const [toDateError, setToDateError] = useState();
  const [weekDaysError, setWeekDaysError] = useState();
  const [statusError, setStatusError] = useState();
  const [breakfastError, setBreakfastError] = useState();
  const [lunchError, setLunchError] = useState();
  const [dinnerError, setDinnerError] = useState();
  const [reservationTypesError, setReservationTypesError] = useState();
  const history = useHistory();

  const dispatch = useDispatch();

  const {
    cafeNamesList,
    inserNewReservationTimingFailedMessageList,
    insertNewReservationTimingFailed,
    insertNewReservationTimingMessage,
    updateReservationTimingMessageList,
  } = useSelector(state => ({
    cafeNamesList: state.cafesReducer.cafeNamesList,
    inserNewReservationTimingFailedMessageList:
      state.reservationTimetableReducer
        .inserNewReservationTimingFailedMessageList,
    insertNewReservationTimingFailed:
      state.reservationTimetableReducer.insertNewReservationTimingFailed,
    insertNewReservationTimingMessage:
      state.reservationTimetableReducer.insertNewReservationTimingMessage,
    updateReservationTimingMessageList:
      state.reservationTimetableReducer.updateReservationTimingMessageList,
  }));

  const [controls, setControls] = useSetState({
    selectedCafeId: '',
    cafeItem: '',
    fromDate: '',
    toDate: '',
    weekDays: [],
    hasBreakfast: false,
    breakfastFromTime: '00:00',
    breakfastToTime: '00:00',
    hasLunch: false,
    lunchFromTime: '00:00',
    lunchToTime: '00:00',
    hasDinner: false,
    dinnerFromTime: '00:00',
    dinnerToTime: '00:00',
    reserveTypes: [],
    mealsInfo: [],
    status: '',
  });

  const cafeList = cafeNamesList => {
    const listItems = cafeNamesList.map(cafe => ({
      value: cafe.id,
      label: cafe.name,
    }));

    return listItems;
  };

  const onChangeValue = (controleName, value) => {
    if (controleName === 'weekDays') {
      let newArray = [...controls.weekDays];
      value.value
        ? newArray.push(value.key)
        : (newArray = newArray.filter(e => e !== value.key));
      setControls({ weekDays: newArray });
    } else if (controleName === 'hasBreakfast') {
      setControls({ hasBreakfast: value });
      if (!value) {
        const breakfastIndex = controls.mealsInfo.findIndex(item => item.mealType == 'BREAKFAST');
        setControls({ breakfastFromTime: null });
        setControls({ breakfastToTime: null });
        controls.mealsInfo.splice(breakfastIndex, 1);
      }
    } else if (controleName === 'hasLunch') {
      setControls({ hasLunch: value });
      if (!value) {
        const lunchIndex = controls.mealsInfo.findIndex(item => item.mealType == 'LUNCH');
        setControls({ lunchFromTime: null });
        setControls({ lunchToTime: null });
        controls.mealsInfo.splice(lunchIndex, 1);
      }
    } else if (controleName === 'hasDinner') {
      setControls({ hasDinner: value });
      if (!value) {
        const dinnerIndex = controls.mealsInfo.findIndex(item => item.mealType == 'DINNER');
        setControls({ dinnerFromTime: null });
        setControls({ dinnerToTime: null });
        controls.mealsInfo.splice(dinnerIndex, 1);
      }
    } else if (controleName === 'reserveTypes') {
      let newArray = [...controls.reserveTypes];
      value.value
        ? newArray.push(value.key)
        : (newArray = newArray.filter(e => e !== value.key));
      setControls({ reserveTypes: newArray });
    } else {
      setControls({ [controleName]: value });
    }
  };

  const hasRseeAdminPermission = permissionHelper.hasUserPermission(
    ENUMS.PERMISSIONS.values
      .AUTO_GENERATE_RESERVE_DATES_AND_HOURS_FOR_ALL_CAFES,
  );

  const validateForm = () => {
    return new Promise((resolve, reject) => {
      let isCafeItemValid = false;
      let isFromDateValid = false;
      let isToDateValid = false;
      let isWeekDaysValid = false;
      let isStatusValid = false;
      let isReserveTypesValid = false;
      let isBreakfastValid = false;
      let isLunchValid = false;
      let isDinnerValid = false;

      if (hasRseeAdminPermission && !controls.cafeItem) {
        isCafeItemValid = false;
        setCafeItemInputError(locales('messages.selecting.cafe.is.mandatory'));
      } else {
        isCafeItemValid = true;
        setCafeItemInputError(null);
      }

      if (!controls.fromDate) {
        isFromDateValid = false;
        setFromDateError(
          locales('messages.fieldValueIsRequired', {
            fieldName: locales('fields.startDate'),
          }),
        );
      } else {
        isFromDateValid = true;
        setFromDateError(null);
      }

      if (!controls.toDate) {
        isToDateValid = false;
        setToDateError(
          locales('messages.fieldValueIsRequired', {
            fieldName: locales('fields.endDate'),
          }),
        );
      } else {
        isToDateValid = true;
        setToDateError(null);
      }

      if (!controls.weekDays || !controls.weekDays.length) {
        isWeekDaysValid = false;
        setWeekDaysError(locales('messages.selectOneWeekdayIsMandatory'));
      } else {
        isWeekDaysValid = true;
        setWeekDaysError(null);
      }

      if (!controls.status) {
        isStatusValid = false;
        setStatusError(
          locales('messages.selectValueForFieldIsMandatory', {
            fieldName: locales('fields.status'),
          }),
        );
      } else {
        isStatusValid = true;
        setStatusError(null);
      }

      if (controls.hasBreakfast) {
        if (
          !controls.breakfastFromTime ||
          !controls.breakfastToTime ||
          controls.breakfastFromTime >= controls.breakfastToTime
        ) {
          isBreakfastValid = false;
          setBreakfastError(
            locales('messages.breakfastFromTimeMustBeLessThanItsToTime'),
          );
        } else {
          setBreakfastError(null);
          isBreakfastValid = true;
        }
      } else {
        setBreakfastError(null);
        isBreakfastValid = true;
      }

      if (controls.hasLunch) {
        if (
          !controls.lunchFromTime ||
          !controls.lunchToTime ||
          controls.lunchFromTime >= controls.lunchToTime
        ) {
          isLunchValid = false;
          setLunchError(
            locales('messages.lunchFromTimeMustBeLessThanItsToTime'),
          );
        } else {
          setLunchError(null);
          isLunchValid = true;
        }
      } else {
        setLunchError(null);
        isLunchValid = true;
      }

      if (controls.hasDinner) {
        if (
          !controls.dinnerFromTime ||
          !controls.dinnerToTime ||
          controls.dinnerFromTime >= controls.dinnerToTime
        ) {
          isDinnerValid = false;
          setDinnerError(
            locales('messages.dinnerFromTimeMustBeLessThanItsToTime'),
          );
        } else {
          setDinnerError(null);
          isDinnerValid = true;
        }
      } else {
        setDinnerError(null);
        isDinnerValid = true;
      }

      if (!controls.reserveTypes || !controls.reserveTypes.length) {
        isReserveTypesValid = false;
        setReservationTypesError(
          locales('messages.selectOneItemIsMandatory', {
            itemName: locales('fields.reserve.type'),
          }),
        );
      } else {
        isReserveTypesValid = true;
        setReservationTypesError(null);
      }

      const isFormValid =
        isCafeItemValid &&
        isFromDateValid &&
        isToDateValid &&
        isWeekDaysValid &&
        isStatusValid &&
        isBreakfastValid &&
        isLunchValid &&
        isDinnerValid &&
        isReserveTypesValid;

      if (!isFormValid) {
        resolve(false);
      } else {
        resolve(true);
      }
    });
  };

  const onSubmit = e => {
    e.preventDefault();

    const isFormValid = validateForm();
    if (!isFormValid) {
      return;
    };

    const updateMealsList = [...controls.mealsInfo];
    const breakfastIndex = controls.mealsInfo.findIndex(item => item.mealType == 'BREAKFAST');
    const lunchIndex = controls.mealsInfo.findIndex(item => item.mealType == 'LUNCH');
    const dinnerIndex = controls.mealsInfo.findIndex(item => item.mealType == 'DINNER');

    if (controls.hasBreakfast && breakfastIndex >= 0) {
      updateMealsList[breakfastIndex] = {
        mealType: ENUMS.MEAL_PORTIONS.values.BREAKFAST,
        fromTime: controls.breakfastFromTime,
        toTime: controls.breakfastToTime,
      };
    } else if (controls.hasBreakfast && breakfastIndex < 0) {
      updateMealsList.push({
        mealType: ENUMS.MEAL_PORTIONS.values.BREAKFAST,
        fromTime: controls.breakfastFromTime,
        toTime: controls.breakfastToTime,
      });
    };

    if (controls.hasLunch && lunchIndex >= 0) {
      updateMealsList[lunchIndex] = {
        mealType: ENUMS.MEAL_PORTIONS.values.LUNCH,
        fromTime: controls.lunchFromTime,
        toTime: controls.lunchToTime,
      };
    } else if (controls.hasLunch && lunchIndex < 0) {
      updateMealsList.push({
        mealType: ENUMS.MEAL_PORTIONS.values.LUNCH,
        fromTime: controls.lunchFromTime,
        toTime: controls.lunchToTime,
      });
    };

    if (controls.hasDinner && dinnerIndex >= 0) {
      updateMealsList[dinnerIndex] = {
        mealType: ENUMS.MEAL_PORTIONS.values.DINNER,
        fromTime: controls.dinnerFromTime,
        toTime: controls.dinnerToTime,
      };
    } else if (controls.hasDinner && dinnerIndex < 0) {
      updateMealsList.push({
        mealType: ENUMS.MEAL_PORTIONS.values.DINNER,
        fromTime: controls.dinnerFromTime,
        toTime: controls.dinnerToTime,
      });
    };

    const standardFromDate = formatter.toStandard(
      jmoment(controls.fromDate).format('jYYYY/jMM/jDD'),
    );
    const standardToDate = formatter.toStandard(
      jmoment(controls.toDate).format('jYYYY/jMM/jDD'),
    );

    let data = {
      fromDate: standardFromDate,
      toDate: standardToDate,
      weekDays: controls.weekDays,
      mealsInfo: updateMealsList,
      reserveTypes: controls.reserveTypes,
    };

    if (hasRseeAdminPermission) {
      data = {
        ...data,
        selectedCafeId: controls.selectedCafeId,
      };
    };

    if (controls.status !== 'OPEN') {
      data = {
        ...data,
        status: controls.status,
      };
    };

    if (props.location.editMode) {
      data = {
        ...data,
        id: props.location.item.id,
      };
      dispatch(editReservationTiming(data))
        .then(() => {
          history.push('/reservation-timing');
        })
        .catch(error => console.log('error', error));
    } else {
      dispatch(newReservationTiming(data))
        .then(() => {
          history.push('/reservation-timing');
        })
        .catch(error => console.log('error', error));
    };
  };

  const handleMealsInfo = () => {
    controls.mealsInfo.map(item => {
      if (item.mealType === 'BREAKFAST') {
        onChangeValue('hasBreakfast', true);
        onChangeValue('breakfastFromTime', item.fromTime);
        onChangeValue('breakfastToTime', item.toTime);
      } else if (item.mealType === 'LUNCH') {
        onChangeValue('hasLunch', true);
        onChangeValue('lunchFromTime', item.fromTime);
        onChangeValue('lunchToTime', item.toTime);
      } else if (item.mealType === 'DINNER') {
        onChangeValue('hasDinner', true);
        onChangeValue('dinnerFromTime', item.fromTime);
        onChangeValue('dinnerToTime', item.toTime);
      }
    });
  };

  useEffect(() => {
    if (props.location.editMode) {
      onChangeValue('cafeItem', props.location.item.cafeName);
      onChangeValue('selectedCafeId', props.location.item.cafeId);
      dispatch(getReservationTimingDetails(props.location.item.id)).then(
        res => {
          onChangeValue('fromDate', res.payload.fromDate);
          onChangeValue('toDate', res.payload.toDate);
          setControls({ weekDays: res.payload.weekDays });
          setControls({ reserveTypes: res.payload.reserveTypes });
          onChangeValue('mealsInfo', [...res.payload.mealsInfo]);
          onChangeValue('status', res.payload.status);
        },
      );
    } else if (hasRseeAdminPermission && !props.location.editMode) {
      dispatch(getAllCafeNamesForPanel());
    }
  }, []);

  useEffect(() => {
    handleMealsInfo();
  }, [controls.mealsInfo]);

  return (
    <>
      <section className='col-12 d-flex justify-content-between align-items-center'>
        <h3 className='text-right text-muted py-4'>
          {locales('insert.new.reservation.timing')}
        </h3>
        <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_CAFE_SCHEDULE || ENUMS.PERMISSIONS.values.ADD_NEW_CAFE_SCHEDULE}>
          <div className='form-actions'>
            <button
              type='submit'
              form='addOrEditForm'
              className='btn btn-success px-2 mx-3'
            >
              <i className='fa fa-save' />
              {locales('labels.save')}
            </button>
            <Link to='/reservation-timing' className='btn btn-default'>
              <i className='fa fa-reply' />
              {locales('label.cancel')}
            </Link>
          </div>
        </ShowForPermission>
      </section>

      <section className='panel panel-default'>
        <div className='panel-heading'>
          <h3 className='panel-title'>
            <i className='fa fa-pencil' />
            {props.location.editMode
              ? locales('title.edit.timing')
              : locales('title.create.new.timing')}
          </h3>
        </div>

        <div className='panel-body'>
          <form onSubmit={onSubmit} id='addOrEditForm'>
            <div className='form-row' id='failed-message'>
              <FailedMessagesList
                className='col errors-list'
                messagesList={
                  props.location.editMode
                    ? updateReservationTimingMessageList
                    : inserNewReservationTimingFailedMessageList
                }
              />
              {(!inserNewReservationTimingFailedMessageList ||
                !inserNewReservationTimingFailedMessageList.length) &&
                insertNewReservationTimingFailed && (
                  <div
                    className={`col errors-list alert alert-danger alert-dismissible fade show`}
                    role='alert'
                  >
                    <ul>
                      {insertNewReservationTimingFailed && (
                        <li>{insertNewReservationTimingMessage}</li>
                      )}
                    </ul>
                  </div>
                )}
            </div>

            <div className='form-row'>
              <h6 className='text-danger mx-5 my-3 font-weight-bold'>
                {props.location.editMode
                  ? locales('title.save.edit.timing.after.seven.days')
                  : null}
              </h6>
            </div>

            <div className='form-row' id='cafe-item'>
              <ShowForPermission
                permission={
                  ENUMS.PERMISSIONS.values
                    .AUTO_GENERATE_RESERVE_DATES_AND_HOURS_FOR_ALL_CAFES
                }
              >
                <div className='form-group col d-flex required'>
                  <label className='rsee-form-label'>
                    {locales('fields.cafe')}
                  </label>
                  <div className='full-width'>
                    {props.location.editMode ? (
                      <input type='text' value={controls.cafeItem} disabled />
                    ) : (
                      <Select
                        id='cafeIds'
                        name='cafeIds'
                        className={`rc-dropdown ${!!cafeItemInputError ? 'is-invalid' : ''
                          }`}
                        placeholder={locales('messages.select.cafe')}
                        isMulti={false}
                        options={cafeList(cafeNamesList)}
                        onChange={e => {
                          onChangeValue('selectedCafeId', e.value);
                          onChangeValue('cafeItem', e.label);
                        }}
                      />
                    )}
                    <div className='invalid-feedback'>{cafeItemInputError}</div>
                  </div>
                </div>
              </ShowForPermission>
            </div>

            <div className='form-row'>
              <div className='form-group col d-flex required'>
                <label className='rsee-form-label'>
                  {locales('fields.from.date')}
                </label>
                <div className='full-width'>
                  <DatePicker
                    marge={true}
                    placeholder={locales('fields.startDate')}
                    name='fromDate'
                    onChange={val => onChangeValue('fromDate', val)}
                    value={controls.fromDate}
                    className={`p-0 date-picker-input start rounded py-2 rc-date-input`}
                  />
                  <div
                    className={`invalid-feedback ${!!fromDateError ? 'is-invalid-feedback' : ''
                      }`}
                  >
                    {fromDateError}
                  </div>
                </div>
              </div>
              <div className='form-group col d-flex required'>
                <label className='rsee-form-label'>
                  {locales('fields.to.date')}
                </label>
                <div className='full-width'>
                  <DatePicker
                    marge={true}
                    placeholder={locales('fields.endDate')}
                    name='toDate'
                    onChange={val => onChangeValue('toDate', val)}
                    value={controls.toDate}
                    className={`p-0 date-picker-input start rounded py-2 rc-date-input`}
                  />
                  <div
                    className={`invalid-feedback ${!!toDateError ? 'is-invalid-feedback' : ''
                      }`}
                  >
                    {toDateError}
                  </div>
                </div>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col d-flex required'>
                <label className='rsee-form-label'>
                  {locales('fields.weed.days')}
                </label>
                <div className='full-width'>
                  <div className='checkboxgroup'>
                    {/* NOTE: */}
                    {ENUMS.SCHEDULE_WEEK_DAYS.list.map(item => {
                      return (
                        <div key={item.value} className='form-check-inline'>
                          <label className='form-check-label'>
                            <input
                              type='checkbox'
                              className='form-check-input'
                              value={item.value}
                              onChange={e =>
                                onChangeValue('weekDays', {
                                  key: e.target.value,
                                  value: e.target.checked,
                                })
                              }
                              checked={controls.weekDays.some(
                                elem => elem === item.value,
                              )}
                            />
                            {locales(item.title)}
                          </label>
                        </div>
                      );
                    })}
                  </div>
                  <div
                    className={`invalid-feedback ${!!weekDaysError ? 'is-invalid-feedback' : ''
                      }`}
                  >
                    {weekDaysError}
                  </div>
                </div>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col d-flex required'>
                <label className='rsee-form-label'>
                  {locales('titles.table')}
                </label>
                <div className='full-width'>
                  <div className='form-check-inline'>
                    <label className='form-check-label'>
                      <input
                        type='radio'
                        className='form-check-input'
                        name='tables'
                        checked
                        disabled
                      />
                      {locales('title.default.cafe.tables')}
                    </label>
                  </div>
                </div>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col d-flex required'>
                <label className='rsee-form-label'>
                  {locales('fields.status')}
                </label>
                <div className='full-width'>
                  {ENUMS.RESERVATION_STATUS.list.map(item => (
                    <div className='form-check-inline' key={item.value}>
                      <label className='form-check-label'>
                        <input
                          type='radio'
                          className='form-check-input'
                          name='optstatus'
                          checked={controls.status === item.value}
                          onChange={e => onChangeValue('status', item.value)}
                        />
                        {item.title}
                      </label>
                    </div>
                  ))}
                  <div
                    className={`invalid-feedback ${!!statusError ? 'is-invalid-feedback' : ''
                      }`}
                  >
                    {statusError}
                  </div>
                </div>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col d-flex'>
                <label className='rsee-form-label'>
                  {locales('fields.day.meals')}
                </label>
                <div className='d-flex row m-0'>
                  <div
                    className={`border rounded flex-fill col-sm-12 col-md-3 ${style.mealTimeBox}`}
                  >
                    <div
                      className={`form-check-inline ${style.mealCheckContainer}`}
                    >
                      <label className='form-check-label'>
                        <input
                          type='checkbox'
                          className='form-check-input'
                          checked={controls.hasBreakfast}
                          onChange={e =>
                            onChangeValue('hasBreakfast', e.target.checked)
                          }
                        />
                        {locales('labels.meals.breakfast')}
                      </label>
                    </div>
                    <label className={style.fromTimeLabel}>
                      {locales('fields.from')}
                    </label>
                    <RseeTimePicker
                      onChange={e => onChangeValue('breakfastFromTime', e)}
                      value={controls.breakfastFromTime}
                      disabled={!controls.hasBreakfast}
                      className={style.fromTimePicker}
                    />
                    <label className={style.toTimeLabel}>
                      {locales('fields.to')}
                    </label>
                    <RseeTimePicker
                      onChange={e => onChangeValue('breakfastToTime', e)}
                      value={controls.breakfastToTime}
                      disabled={!controls.hasBreakfast}
                      className={style.toTimePicker}
                    />
                    <div
                      className={`invalid-feedback ${!!breakfastError ? 'is-invalid-feedback' : ''
                        }`}
                    >
                      {breakfastError}
                    </div>
                  </div>
                  <div
                    className={`border rounded flex-fill col-sm-12 col-md-3 ${style.mealTimeBox}`}
                  >
                    <div
                      className={`form-check-inline ${style.mealCheckContainer}`}
                    >
                      <label className='form-check-label'>
                        <input
                          type='checkbox'
                          className='form-check-input'
                          checked={controls.hasLunch}
                          onChange={e =>
                            onChangeValue('hasLunch', e.target.checked)
                          }
                        />
                        {locales('labels.meals.lunch')}
                      </label>
                    </div>
                    <label className={style.fromTimeLabel}>
                      {locales('fields.from')}
                    </label>
                    <RseeTimePicker
                      onChange={e => onChangeValue('lunchFromTime', e)}
                      value={controls.lunchFromTime}
                      disabled={!controls.hasLunch}
                      className={style.fromTimePicker}
                    />
                    <label className={style.toTimeLabel}>
                      {locales('fields.to')}
                    </label>
                    <RseeTimePicker
                      onChange={e => onChangeValue('lunchToTime', e)}
                      value={controls.lunchToTime}
                      disabled={!controls.hasLunch}
                      className={style.toTimePicker}
                    />
                    <div
                      className={`invalid-feedback ${!!lunchError ? 'is-invalid-feedback' : ''
                        }`}
                    >
                      {lunchError}
                    </div>
                  </div>
                  <div
                    className={`border rounded flex-fill col-sm-12 col-md-3 ${style.mealTimeBox}`}
                  >
                    <div
                      className={`form-check-inline ${style.mealCheckContainer}`}
                    >
                      <label className='form-check-label'>
                        <input
                          type='checkbox'
                          className='form-check-input'
                          checked={controls.hasDinner}
                          onChange={e =>
                            onChangeValue('hasDinner', e.target.checked)
                          }
                        />
                        {locales('labels.meals.dinner')}
                      </label>
                    </div>
                    <label className={style.fromTimeLabel}>
                      {locales('fields.from')}
                    </label>
                    <RseeTimePicker
                      onChange={e => onChangeValue('dinnerFromTime', e)}
                      value={controls.dinnerFromTime}
                      disabled={!controls.hasDinner}
                      className={style.fromTimePicker}
                    />
                    <label className={style.toTimeLabel}>
                      {locales('fields.to')}
                    </label>
                    <RseeTimePicker
                      onChange={e => onChangeValue('dinnerToTime', e)}
                      value={controls.dinnerToTime}
                      disabled={!controls.hasDinner}
                      className={style.toTimePicker}
                    />
                    <div
                      className={`invalid-feedback ${!!dinnerError ? 'is-invalid-feedback' : ''
                        }`}
                    >
                      {dinnerError}
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className='form-row'>
              <div className='form-group col d-flex required'>
                <label className='rsee-form-label'>
                  {locales('fields.reserve.type')}
                </label>
                <div className='full-width'>
                  <div className='checkboxgroup'>
                    {ENUMS.RESERVATION_TYPES.list.map(item => (
                      <div className='form-check-inline' key={item.value}>
                        <label className='form-check-label'>
                          <input
                            type='checkbox'
                            className='form-check-input'
                            value={item.value}
                            onChange={e => onChangeValue('reserveTypes', {
                              key: e.target.value,
                              value: e.target.checked,
                            })
                            }
                            checked={controls.reserveTypes.some(
                              elem => elem === item.value,
                            )}
                          />
                          {item.title}
                        </label>
                      </div>
                    ))}
                  </div>
                  <div
                    className={`invalid-feedback ${!!reservationTypesError ? 'is-invalid-feedback' : ''
                      }`}
                  >
                    {reservationTypesError}
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </section>
    </>
  );
};

export default AddOrEditReservationTiming;
